<template>
  <v-avatar
    :size="size"
    :color="bg"
  >
    <v-img :src="hubatar"
           @error="onAvatarError"
           v-if="!showBadge"/>
    <span v-else
          :style="{ fontSize:(size/3)+'px' }">
      {{ initials }}
    </span>
  </v-avatar>
</template>

<style type="text/css" scoped>
   
</style>

<script>
  import { mapGetters } from 'vuex'

  import Crypto from '@/plugins/crypto'

  import { avatar } from '@zwan-it/zwan-spaces/lib/utility/avatar'

  export default {
    name: 'UserAvatar',

    mixins: [],

    data: () => ({
      cache: null,
      showBadge: false
    }),

    props: {
      size: {
        type: Number,
        default: 36
      }
    },

    computed: 
    {
      ...mapGetters({
        user: 'auth/user'
      }),

      gravatar()
      {
        const email = this.user ? this.user.email : '',
              hash = Crypto.md5(email)

        return `https://www.gravatar.com/avatar/${hash}?d=404`
      },

      hubatar()
      {
        const email = this.user ? this.user.email : '',
              url = avatar(email),
              hubatar = `${url}?v=${this.cache}`

        return hubatar
      },

      bg()
      {
        return this.showBadge ? 'grey lighten-2' : 'white'
      },

      initials()
      {
        if( !this.user )
          return ''

        return this.user.initials
      }
    },

    methods:
    {
      bindEvents()
      {
        window.addEventListener("message", ({ data }) => {
          if( data.event === 'refresh-avatar' )
            this.refresh()
        })
      },
      
      onAvatarError()
      {
        this.showBadge = true
      },

      refresh()
      {
        this.cache = Math.random()
      }
    },

    mounted()
    {
      this.bindEvents()
    }
  }
</script>
